/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:35:58AM]
Permissions to update outside the main branch: [false]
*/

import { PendingProvider, useCondition } from '@finbeat/react-toolkit';
import {
    sidebarEmployerPortalUserMenu,
    sidebarMenu,
} from 'components/Navigation/Sidebar/sidebarMenu';
import useAuth from 'hooks/useAuth';
import { SidebarProvider } from 'providers/SidebarProvider';
import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from 'reactstrap';
import NavMenu from '../Navigation/NavMenu';
import './Layout.scss';
import Sidebar from '../Navigation/Sidebar/Sidebar';
import { useGeneralSettingsContext } from '../../providers/GeneralSettingsProvider';

export default function Layout() {
    const { auth } = useAuth();
    const className = 'layout';
    const { designType } = useGeneralSettingsContext();

    const menu = useMemo(() => {
        if (!auth) return [];

        if (auth.portalUserEmployerId) return sidebarEmployerPortalUserMenu;

        return sidebarMenu;
    }, [auth]);

    return useCondition(
        designType,
        {
            nova: (
                <div className={className} data-testid="layout">
                    <Outlet />
                </div>
            ),
        },
        <div className={className} data-testid="layout">
            <SidebarProvider mainMenu={menu}>
                <Sidebar />
            </SidebarProvider>
            <div className={`${className}__workspace`}>
                <header>
                    <NavMenu />
                </header>
                <main className={`${className}__content`}>
                    <Container fluid className="position-relative">
                        <PendingProvider>
                            <Outlet />
                        </PendingProvider>
                    </Container>
                </main>
            </div>
        </div>
    );
}
